import { useContext } from "react"
import { GlobalStateContext } from "../components/providers/GlobalStateProvider.jsx"
import { getFbcCookie, getFbpCookie } from "../utils/getFbcCookie.js"

export const useTrackFacebookEvent = () => {
	const { state, dispatch } = useContext(GlobalStateContext)
	const userId = state.userId
	const userEmail = state.userEmail
	const _fbc = getFbcCookie() || null
	const _fbp = getFbpCookie() || null

	return async (eventName) => {
		try {
			return await fetch("/api/facebook/forwardFacebookEvent", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					eventName,
					userId,
					userEmail,
					_fbc,
					_fbp,
				}),
			})
		} catch (error) {
			console.error("useTrackFacebookEvent error", error)
		}
	}
}
